<template>
	<div class="form-group">
		<label
			:style="'color:' + template.style.surveyTextColor"
			class="title-bold"
			for="nome"
		>
			{{ questionText }}
		</label>
		<p
			:style="
				template.style.surveyBgColor
					? { color: template.style.secondColor }
					: { color: black }
			"
			class="observation"
		>
			{{ questionObs }}
		</p>
		<p class="card-subtitle mb-1">
			Você pode fazer upload de arquivos nos seguintes formatos:
		</p>
		<ul class="ml-1">
			<li v-for="(format, i) in formats" :key="i" class="ml-3">
				{{ format }}
			</li>
		</ul>

		<!-- Arquivos selecionados-->
		<div
			class="q-buttonlist-selected"
			vs-align="center"
			vs-type="flex"
			vs-justify="space-around"
			v-show="qtAnwser"
		>
			<button
				:style="
					template.style.surveyBgColor
						? { color: template.style.firstColor }
						: { color: '#212529' }
				"
				class="c-checkbox-container btn-check"
			>
				<span>{{ qtAnwser.split("/").reverse()[0] }} </span>
				<input type="checkbox" checked="checked" disabled />
				<!-- disabled to not uncheck -->
				<span class="checkmark" @click="removeOption"> </span>
			</button>
		</div>

		<div class="d-flex align-items-center">
			<div class="mb-3">
				<input
					id="file"
					ref="file"
					class="file-input"
					type="file"
					@change="uploadFile"
				/>

				<vs-button icon="file_upload">
					<label class="m-0 cursor-pointer" for="file">
						Procurar...
					</label>
				</vs-button>
			</div>

			<p class="mb-0 ml-3">
				{{ fileName ? fileName : "Selecione um arquivo." }}
			</p>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "SurveyUploadFile",
	props: {
		questionText: { type: String },
		questionObs: { type: String, default: '' },
		questionId: { type: Number },
		config: { type: String },
	},
	data: () => ({
		qtAnwser: "",
		processingApi: false,

		formats: ["png", "jpg/jpeg"],
		fileName: "",
	}),
	computed: {
		template() {
			return this.$store.state.template;
		},
	},
	created() {
		if (this.$store.getters.answerValue(this.questionId)) {
			this.qtAnwser = this.$store.getters.answerValue(this.questionId);
		}
	},
	updated() {
		this.focusInput();
	},
	methods: {
		focusInput() {
			this.$refs.fc.$el.focus();
		},
		allKeys() {
			this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
		},
		clearFile() {
			this.Images = {};
			this.fileName = "";
		},
		uploadFile() {
			this.Images = this.$refs.file.files[0];
			this.fileName = this.$refs.file.files[0].name;
			this.submitFile();
		},
		submitFile() {
			const formData = new FormData();
			formData.append("file", this.Images);
			const headers = { "Content-Type": "multipart/form-data" };
			axios
				.post(
					`https://dashapi.fanbase.com.br/api/Files/UserSurveyFile/${this.$store.state.project.ownerId}/${this.$store.state.surveyStruct.surveyId}/${this.$store.state.surveyUserId}/${this.questionId}`,
					formData,
					{ headers }
				)
				.then((res) => {
					let src;
					if (res.data.header.codigo === 1) {
						this.fileName = this.$refs.file.files[0].name
							? this.$refs.file.files[0].name.split(".")[0]
							: "Uploaded image";
						src = res.data.data ? res.data.data[0] : "Src";
						this.$vs.notify({
							color: "success",
							title: "Sucesso de upload",
							text: "Carregamento de arquivos realizado.",
						});
						this.qtAnwser = src;
						this.$emit("AnswerChanged", src, this.questionId);
						this.clearFile();
					} else if (
						res.data.header.codigo === 0 &&
						res.data.header.msg.startsWith("Arquivo já existente")
					) {
						this.fileName = this.$refs.file.files[0].name
							? this.$refs.file.files[0].name.split(".")[0]
							: "Uploaded image";
						src = `https://config.fanbase.com.br/user/fanbase/${this.$store.state.project.ownerId}/files/${this.$refs.file.files[0].name}`;
						this.$vs.notify({
							color: "success",
							title: "Adicionado com sucesso",
							text: "Arquivo encontrado e registrado",
						});
						this.qtAnwser = src;
						this.$emit("AnswerChanged", src, this.questionId);
						this.clearFile();
					} else {
						this.$vs.notify({
							color: "danger",
							title: "Erro de upload",
							text: `${res.data.header.msg}`,
						});
						this.$refs.file.files[0] = 0;
						this.clearFile();
					}
				});
		},
		removeOption() {
			this.qtAnwser = "";
			this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
			this.clearFile();
		},
	},
	directives: {
		focus: {
			// directive definition
			inserted: function(el) {
				el.focus();
			},
		},
	},
};
</script>

<style scoped>
.title-bold {
	font-family: "OxaniumBold";
}
.c-upload >>> .con-input-upload {
	height: 100px;
}
.c-upload {
	width: auto;
}

.file-input {
	display: none;
}

.btn-check {
	border: none;
	background-color: transparent;
}

.btn-check:hover,
.btn-check:focus {
	background-color: transparent !important;
}

.btn-check:focus input ~ .checkmark {
	box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
}

button.c-checkbox-container.btn-check:hover span {
	color: var(--survey-text-color) !important;
}
</style>
